import SEVENTH from "./7th.png";
import FIFTEENTH from "./15th.png";
import TWENTYTHIRD from "./23rd.png";
import FEB from "./feb.png";
import MAR from "./mar.png";
import APR from "./apr.png";
import SEP from "./sep.png";
import AUG from "./aug.png";
import MAY from "./may.png";
import OCT from "./oct.png";

export default {
  SEVENTH,
  FIFTEENTH,
  TWENTYTHIRD,
  FEB,
  MAR,
  APR,
  SEP,
  AUG,
  MAY,
  OCT,
};
